// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1__dfa8f6c58a82a7302b42","cls2":"AuthorHeader-cls2___7eef2d79e05accedd2b AuthorHeader-cls1__dfa8f6c58a82a7302b42"};